import { FC } from "react";

const StepDivider: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101"
      height="2"
      viewBox="0 0 101 2"
      fill="none"
    >
      <path
        d="M100.942 1.00001L0.941895 1"
        stroke="#747981"
        strokeDasharray="2 2"
      />
    </svg>
  );
};

export default StepDivider;
